export default __webpack_public_path__ + "static/media/path_13.63905fb2.png";